import React, { useState } from 'react';
import WithdrawCurrencies from './WithdrawCurrencies';

const AdminBannerDashboard = () => {
return (
	<WithdrawCurrencies />
)};

export default AdminBannerDashboard;